module.exports = __webpack_public_path__ + "img/icn-mb-cashout.a9a6dd6a.png";